/*
 * assets/cv-rental-basket.js — herramientasusadas.es
 * "Cesta de alquiler": permite pedir presupuesto de VARIOS equipos a la vez.
 * El alquiler es lead-gen sin precio (no hay checkout), así que en vez del carrito
 * de Shopify usamos una cesta propia en localStorage. El usuario añade equipos con
 * los botones [data-cvr-add], revisa la lista en un cajón lateral, elige fechas una
 * sola vez y envía UNA solicitud con todos los equipos a /api/fillout/hu-rental-cart-lead.
 * Autocontenido (sin librerías). Se auto-monta al cargarse en cualquier página de alquiler.
 */
(function () {
  if (window.__cvrBasket) return;
  window.__cvrBasket = true;

  var API = 'https://mpb-scraper-production.up.railway.app/api/fillout/hu-rental-cart-lead';
  var KEY = 'cvr_basket_v1';
  var WA = '610367746';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function count(list) {
    return (list || read()).reduce(function (n, it) { return n + (Number(it.units) || 1); }, 0);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // ---- añadir / quitar ----
  function add(item) {
    if (!item || !item.id) return;
    var list = read();
    var ex = list.filter(function (x) { return x.id === item.id; })[0];
    if (ex) { ex.units = (Number(ex.units) || 1) + 1; }
    else {
      list.push({
        id: item.id, title: item.title || '', url: item.url || '',
        img: item.img || '', city: item.city || '', cat: item.cat || '', units: 1
      });
    }
    write(list);
    refresh();
    open();
    pulse();
  }
  function setUnits(id, u) {
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) { list[i].units = Math.max(1, Number(u) || 1); break; }
    }
    write(list);
    refresh();
  }
  function remove(id) {
    write(read().filter(function (x) { return x.id !== id; }));
    refresh();
  }

  // ---- UI ----
  var fab, badge, drawer, panelBody, overlay;

  function build() {
    fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'cvrb-fab';
    fab.setAttribute('aria-label', 'Ver mi solicitud de alquiler');
    fab.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg><span class="cvrb-fab__txt">Mi solicitud</span><span class="cvrb-badge" data-cvrb-badge>0</span>';
    badge = fab.querySelector('[data-cvrb-badge]');
    fab.addEventListener('click', open);

    overlay = document.createElement('div');
    overlay.className = 'cvrb-overlay';
    overlay.addEventListener('click', close);

    drawer = document.createElement('aside');
    drawer.className = 'cvrb-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Solicitud de alquiler');
    drawer.innerHTML =
      '<header class="cvrb-drawer__head">' +
        '<strong>Mi solicitud de alquiler</strong>' +
        '<button type="button" class="cvrb-x" aria-label="Cerrar">&times;</button>' +
      '</header>' +
      '<div class="cvrb-drawer__body" data-cvrb-body></div>';
    drawer.querySelector('.cvrb-x').addEventListener('click', close);
    panelBody = drawer.querySelector('[data-cvrb-body]');

    document.body.appendChild(fab);
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    // La cesta siempre visible (mini-cart persistente) y apilada por ENCIMA del
    // FAB de chat "¿Hablamos?" (.cvp-fab, misma esquina) para que no se tapen.
    var st = document.createElement('style');
    st.textContent =
      '.cvrb-fab{bottom:78px!important}' +
      '.cvrb-fab.is-empty{background:#fff;color:#0f766e;border:1px solid #99f6e4;box-shadow:0 6px 18px rgba(15,118,110,.20)}' +
      '.cvrb-fab.is-empty .cvrb-badge{color:#fff;background:#0f766e}' +
      '@media (max-width:600px){.cvrb-fab{bottom:72px!important}}';
    document.head.appendChild(st);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function pulse() {
    if (!fab) return;
    fab.classList.remove('is-pulse');
    // reflow para reiniciar la animación
    void fab.offsetWidth;
    fab.classList.add('is-pulse');
  }

  function refresh() {
    var list = read();
    var n = count(list);
    if (badge) badge.textContent = n;
    // Siempre visible: el usuario necesita un botón permanente para abrir la
    // "ventana tipo carrito" en cualquier momento, aunque aún no haya añadido nada.
    if (fab) {
      fab.classList.add('is-visible');
      fab.classList.toggle('is-empty', list.length === 0);
    }
    if (drawer && drawer.classList.contains('is-open')) renderBody();
  }

  var today = new Date();
  function isoAddDays(d) {
    var t = new Date(today.getFullYear(), today.getMonth(), today.getDate() + d);
    return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
  }

  function renderBody() {
    var list = read();
    if (!list.length) {
      panelBody.innerHTML =
        '<div class="cvrb-empty">' +
          '<p>Tu solicitud está vacía.</p>' +
          '<p class="cvrb-empty__hint">Añade equipos con el botón <strong>“Añadir a mi solicitud”</strong> y pídenos presupuesto de todos a la vez.</p>' +
          '<a href="/pages/alquiler" class="cvrb-empty__link">Ver catálogo de alquiler →</a>' +
        '</div>';
      return;
    }
    var itemsHtml = list.map(function (it) {
      return '' +
        '<li class="cvrb-item" data-id="' + esc(it.id) + '">' +
          (it.img ? '<img class="cvrb-item__img" src="' + esc(it.img) + '" alt="" loading="lazy">' : '<span class="cvrb-item__img cvrb-item__img--ph"></span>') +
          '<div class="cvrb-item__main">' +
            '<a class="cvrb-item__title" href="' + esc(it.url || '#') + '">' + esc(it.title) + '</a>' +
            (it.city ? '<span class="cvrb-item__city">' + esc(it.city) + '</span>' : '') +
            '<div class="cvrb-qty">' +
              '<button type="button" class="cvrb-qty__btn" data-cvrb-dec aria-label="Menos">−</button>' +
              '<input class="cvrb-qty__in" type="number" min="1" value="' + (Number(it.units) || 1) + '" data-cvrb-units inputmode="numeric">' +
              '<button type="button" class="cvrb-qty__btn" data-cvrb-inc aria-label="Más">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cvrb-item__del" data-cvrb-del aria-label="Quitar">&times;</button>' +
        '</li>';
    }).join('');

    panelBody.innerHTML =
      '<ul class="cvrb-list">' + itemsHtml + '</ul>' +
      '<form class="cvrb-form" data-cvrb-form novalidate>' +
        '<div class="cvrb-dates">' +
          '<label>Desde<input type="date" name="fechaDesde" min="' + isoAddDays(0) + '" value="' + isoAddDays(1) + '"></label>' +
          '<label>Hasta<input type="date" name="fechaHasta" min="' + isoAddDays(0) + '" value="' + isoAddDays(2) + '"></label>' +
        '</div>' +
        '<label class="cvrb-f">Nombre<input type="text" name="name" required autocomplete="name" placeholder="Tu nombre"></label>' +
        '<label class="cvrb-f">Email<input type="email" name="email" required autocomplete="email" placeholder="Para enviarte el presupuesto"></label>' +
        '<label class="cvrb-f">Teléfono <small>(opcional)</small><input type="tel" name="phone" autocomplete="tel" placeholder="Para avisarte antes"></label>' +
        '<label class="cvrb-f">Mensaje <small>(opcional)</small><textarea name="message" rows="2" placeholder="Zona de entrega, dudas…"></textarea></label>' +
        '<p class="cvrb-err" data-cvrb-err hidden></p>' +
        '<button type="submit" class="cvrb-submit">Pedir presupuesto de ' + list.length + (list.length === 1 ? ' equipo' : ' equipos') + '</button>' +
        '<p class="cvrb-legal">Sin compromiso · respuesta en 24 h · o por <a href="https://wa.me/34' + WA + '" target="_blank" rel="noopener">WhatsApp</a></p>' +
      '</form>';

    wireBody(list);
  }

  function wireBody(list) {
    Array.prototype.forEach.call(panelBody.querySelectorAll('.cvrb-item'), function (li) {
      var id = li.getAttribute('data-id');
      var input = li.querySelector('[data-cvrb-units]');
      li.querySelector('[data-cvrb-inc]').addEventListener('click', function () {
        input.value = (Number(input.value) || 1) + 1; setUnits(id, input.value);
      });
      li.querySelector('[data-cvrb-dec]').addEventListener('click', function () {
        input.value = Math.max(1, (Number(input.value) || 1) - 1); setUnits(id, input.value);
      });
      input.addEventListener('change', function () { setUnits(id, input.value); });
      li.querySelector('[data-cvrb-del]').addEventListener('click', function () { remove(id); });
    });

    var form = panelBody.querySelector('[data-cvrb-form]');
    if (!form) return;
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var err = form.querySelector('[data-cvrb-err]');
      var get = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
      var email = get('email');
      if (!email && !get('phone')) {
        err.textContent = 'Déjanos un email o un teléfono para poder responderte.';
        err.hidden = false;
        return;
      }
      var fresh = read();
      var payload = {
        name: get('name'), email: email, phone: get('phone'), message: get('message'),
        fechaDesde: get('fechaDesde'), fechaHasta: get('fechaHasta'),
        city: (fresh[0] && fresh[0].city) || '',
        origen: 'herramientasusadas-alquiler-cesta',
        items: fresh.map(function (it) {
          return { title: it.title, url: it.url, city: it.city, categoria: it.cat, unidades: it.units || 1 };
        })
      };
      var btn = form.querySelector('.cvrb-submit');
      btn.disabled = true; btn.textContent = 'Enviando…';
      fetch(API, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          write([]);
          refresh();
          success(payload.items.length);
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'Reintentar';
          err.textContent = 'No se pudo enviar. Reinténtalo o escríbenos por WhatsApp al ' + WA + '.';
          err.hidden = false;
        });
    });
  }

  function success(n) {
    panelBody.innerHTML =
      '<div class="cvrb-ok">' +
        '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>' +
        '<h3>¡Solicitud enviada!</h3>' +
        '<p>Te enviaremos el presupuesto de ' + n + (n === 1 ? ' equipo' : ' equipos') + ' al email que nos has dejado, normalmente el mismo día.</p>' +
        '<a href="/pages/alquiler" class="cvrb-ok__link">Seguir viendo equipos</a>' +
      '</div>';
  }

  function open() {
    if (!drawer) return;
    renderBody();
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.classList.add('cvrb-lock');
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('cvrb-lock');
  }

  // ---- delegación de botones "Añadir" ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cvr-add]');
    if (!btn) return;
    e.preventDefault();
    add({
      id: btn.getAttribute('data-id'),
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      img: btn.getAttribute('data-img'),
      city: btn.getAttribute('data-city'),
      cat: btn.getAttribute('data-cat')
    });
    var was = btn.getAttribute('data-label') || btn.textContent;
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', was);
    btn.classList.add('is-added');
    btn.textContent = '✓ Añadido';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = btn.getAttribute('data-label');
    }, 1400);
  });

  function init() {
    build();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
